/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AppIcon extends BaseIcon {
    getChildren = () => [
        <path fill={this.getColor()}
              d="M14,8h-1V4H9V3c0-1.1-0.9-2-2-2S5,1.9,5,3v1H1v4h1c1.1,0,2,0.9,2,2s-0.9,2-2,2H1v4h4v-1c0-1.1,0.9-2,2-2s2,0.9,2,2v1h4v-4h1c1.1,0,2-0.9,2-2S15.1,8,14,8z"/>
    ]
    getViewBox = () => '0 0 16 16'
}
